import isHoliday from "@/util/is-holiday";
import { mdiRocketLaunch } from "@mdi/js";

export const useQuoteAndApplyIcon = () => {
  const holiday = isHoliday();
  return holiday?.quoteAndApplyIcon || mdiRocketLaunch;
};
